/**
 * Ingredients Tabs functionality
 * Handles tab switching and popup for the ingredients tabs section
 */
document.addEventListener('DOMContentLoaded', function() {
  // Find all ingredients tabs sections (identified by the nav container)
  const navContainers = document.querySelectorAll('[data-ingredients-tabs-nav]');

  navContainers.forEach(navContainer => {
    const section = navContainer.closest('section');
    if (!section) return;

    const tabs = navContainer.querySelectorAll('.ingredients-tab');
    const contentWrappers = section.querySelectorAll('.ingredient-content-wrapper');

    // Tab switching
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const index = this.getAttribute('data-index');

        // Update active tab
        tabs.forEach(t => t.classList.remove('ingredients-tab--active'));
        this.classList.add('ingredients-tab--active');

        // Show/hide content wrappers
        contentWrappers.forEach(wrapper => {
          if (wrapper.getAttribute('data-index') === index) {
            wrapper.classList.remove('hidden');
          } else {
            wrapper.classList.add('hidden');
          }
        });
      });
    });
  });
});






function styleShopifyFormByWrapper({ wrapperId, debug = false }) {
  const log = (...args) => debug && console.log("[ShopifyFormStyle]", ...args);

  document.addEventListener("DOMContentLoaded", () => {
    const observer = new MutationObserver(() => {
      const wrapper = document.querySelector(`[data-forms-id="${wrapperId}"]`);
      if (!wrapper) return;

      const formEmbed = wrapper.querySelector("shopify-forms-embed");
      if (!formEmbed || !formEmbed.shadowRoot) return;

      if (formEmbed.shadowRoot.querySelector("style[data-custom-style]")) {
        observer.disconnect();
        return;
      }

      const emailInput = formEmbed.shadowRoot.querySelector('#email');
if (emailInput && !emailInput.placeholder) {
  emailInput.setAttribute('placeholder', 'Email');
}

      const style = document.createElement("style");
      style.setAttribute("data-custom-style", "true");

      style.textContent = `
      @font-face {
  font-family: 'Oakes Grotesk';
  src: url('https://cdn.shopify.com/s/files/1/0958/6455/3774/files/OakesGrotesk-Regular.woff2') format('woff2'),
       url('https://cdn.shopify.com/s/files/1/0958/6455/3774/files/OakesGrotesk-Regular.woff') format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
  /* APPLY FONT TO EVERYTHING INSIDE FORM */
[data-form-root="true"],
[data-form-root="true"] * {
  font-family: 'Oakes Grotesk', sans-serif !important;
  font-weight: 400 !important;
}
      form._formFieldset_cit2d_82  {
      padding:  5px !important;
      }
        /* FORM WRAPPER BACKGROUND */
        [data-form-root="true"] {
          background: #f1ead5 !important;
          
        }

        /* REMOVE GRID IMAGE COLUMN */
        [data-sizing="form-wrapper"] > section {
          display: block !important;
        }

div:empty {
    display: none;
}
@media (max-width: 767px) {
    ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
        max-width: 100% !important;
        min-width: 77vw !important;
    }
}
._gridItemContent_1q1d2_257 {
    
    padding-bottom: 0 !important;
}

        /* INPUT FIELDS */
        input[type="text"],
input[type="email"]  {
          background: #f1ead5 !important;
          border: 1px solid #ec4b30 !important;
          border-radius: 50px !important;
          height: 60px !important;
          padding: 0 24px !important;
          font-size: 14px !important;
          width: 100% !important;
          box-sizing: border-box !important;
          box-shadow: none !important;
          color:  #ec4b30 !important;
        }

        /* LABELS */
        label {
          color: #ec4b30 !important;
          font-weight: 500 !important;
        }

        /* PHONE CONTAINER FIX */
/* PHONE WRAPPER AS SINGLE INPUT */
._formPhoneInputContainer_piv1u_6 {
  display: flex !important;
  align-items: center !important;
  background: #f1ead5 !important;
  border: 1px solid #ec4b30 !important;
  border-radius: 50px !important;
  height: 60px !important;
  padding: 0 18px 0 0px !important;
  box-sizing: border-box !important;
  gap: 2px !important;
}

/* REMOVE INNER INPUT BORDER */
._formPhoneInputField_piv1u_17 {
  border: none !important;
  outline: none !important;
  background: transparent !important;
  height: 100% !important;
  flex: 1 !important;
  padding: 0 !important;
  font-size: 14px !important;
  box-shadow: none !important;
}

/* REMOVE COUNTRY BUTTON BORDER */
.phone-country-selector button {
border: none !important;
    background: transparent !important;
    height: 100% !important;
    padding: 0px !important;
    display: flex !important;
    align-items: center !important;
    max-height: 100%;
    box-shadow: none !important;
    padding-left: 28px !important;
}

/* REMOVE OUTER FIELD CONTAINER PADDING */
._formPhoneInputContainer_piv1u_6 ._formFieldContainer_1mxsl_5 {
  padding: 0 !important;
  margin: 0 !important;
}

/* LABEL COLOR */
._formPhoneInputContainer_piv1u_6 label {
  color: #ec4b30 !important;
}
  

        /* SUBMIT BUTTON */
        button[type="submit"] {
            background: #ec4b30 !important;
            color: #fff !important;
            border: none !important;
            border-radius: 150px !important;
            font-weight: 700 !important;
            font-size: 15px !important;
            letter-spacing: 0px !important;
            margin-top: 0 !important;
            padding: 20px 10px !important;
        }  
            /* HIDE FLOATING LABELS */
label {
  display: none !important;
}
  /* PLACEHOLDER STYLE */
input::placeholder {
  color: #ec4b30 !important;
  opacity: 1 !important;
  
} 
  /* PHONE PLACEHOLDER COLOR */
._formPhoneInputField_piv1u_17::placeholder {
  color: #ec4b30 !important;
  opacity: 1 !important;
}  
  
/* REMOVE DEFAULT FOCUS STYLES */
/* HARD RESET EMAIL FOCUS */
input[type="text"]:focus,
input[type="email"]:focus,
input[type="text"]:active,
input[type="email"]:active {
  border-color: #ec4b30 !important; /* keep same border */
  box-shadow: none !important;
  outline: 1px dashed #ec4b30 !important;
  outline-offset: 3.75px !important;
}

/* EMAIL FIELD FOCUS */
input[type="text"]:focus,
input[type="email"]:focus {
  outline-width: 1px !important;
  outline-style: dashed !important;
  outline-color: #ec4b30 !important;
  outline-offset: 3.75px !important;
}

/* PHONE FIELD FOCUS (WRAPPER LEVEL) */
._formPhoneInputContainer_piv1u_6:focus-within {
  outline-width: 1px !important;
  outline-style: dashed !important;
  outline-color: #ec4b30 !important;
  outline-offset: 3.75px !important;
}

div._formFieldContainer_1mxsl_5 {
    width: 100% !important;
    height: 100%;
}

/* PHONE INPUT TEXT COLOR */
._formPhoneInputField_piv1u_17 {
  color: #ec4b30 !important;
}

div#country-selector-dropdown,
._dropdownContainer_12thd_63._showUpwards_12thd_79 {
    max-height: 200px !important;
min-height: 200px !important;
height:  200px !important;
}
div[class*="_dropdownContainer"] {
  max-height: 200px !important;
  overflow: visible !important;
}

div[class*="_dropdownContainer"] * {
  max-height: none !important;
}

div[class*="_dropdownContainer"] ul {
  max-height: 200px !important;
  overflow-y: auto !important;
}
  ._formContainer_1q1d2_30 {
  overflow: visible !important;
}

/* REMOVE ALL CLIPPING ABOVE DROPDOWN */
._selectContainer_12thd_6,
.phone-country-selector,
._formPhoneInputContainer_piv1u_6,
._formContainer_1q1d2_30,
._inline_1q1d2_47 {
  overflow: visible !important;
}

._formError_1mxsl_21 {
font-size: 12px;
}

/* PHONE CONTAINER SHOULD STACK */
._formPhoneInputContainer_piv1u_6 {
  position: relative !important;
}._formPhoneInputContainer_piv1u_6 ._formError_1mxsl_21 {
  position: absolute !important;
  bottom: -18px !important;
  left: 0 !important;
  width: 100% !important;
  font-size: 12px !important;
  color: #ec4b30 !important;
}._formPhoneInputContainer_piv1u_6 {
  margin-bottom: 10px !important;
}
  output._formError_1mxsl_21 {
    font-size: 12px !important;
    margin-top: -8px;
}

h2._formBannerHeading_z5ku3_9,
._textBody_2aowh_10 p{
    color: #ec4b30 !important;
}
      `;

      formEmbed.shadowRoot.appendChild(style);
      log("Injected improved layout + styling.");
      observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
}

styleShopifyFormByWrapper({
  wrapperId: "forms-root-892148",
  debug: true
});
